import { POColumns } from "../../ColumnsConfig/POColumns";
import Table from "../../Components/Table";
import React, { useState, useEffect } from "react";
import "./../../App.css";
import ConfirmationModal from "../../Common/ConfirmationModal";
import { fetchPO } from "../../Services/PoException";
import { fetchStores } from "../../Services/Store";
import {
  Box,
  Button,
  MenuItem,
  Select,
  FormControl,
  TextField,
  InputLabel,
} from "@mui/material";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import loaderGif from "../../Assests/loader.gif";

//import { PORows } from '../../Utils/MockData'; // Import the mock data

const PO = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [initialData, setInitialData] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [isDenyModalOpen, setIsDenyModalOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [sortBy, setSortColumn] = useState("");
  const [order, setSortOrder] = useState("asc");
  const [storeOptions, setStoreOptions] = useState([]);
  const [isLoadingStores, setIsLoadingStores] = useState(false);
  const [storeError, setStoreError] = useState(null);
  const validSortFields = [
    "po_number",
    "department_number",
    "store_number",
    "created_at",
    "updated_at",
    "status",
  ];

  const [filters, setFilters] = useState({
    poNumber: "",
    dept: "",
    store: "",
    routingStatus: "Pending",
    startDate: "",
    endDate: "",
  });
  const [searchFilters, setSearchFilters] = useState({
    poNumber: "",
    dept: "",
    store: "",
    routingStatus: "Pending",
    startDate: "",
    endDate: "",
  });
  useEffect(() => {
    const fetchStoreData = async () => {
      setIsLoadingStores(true);
      setStoreError(null);

      try {
        const response = await fetchStores();
        console.log("Raw store data:", response.data);

        // Filter stores with exception_allowed set to 1
        const filteredStores = response.data.filter(
          (store) => store.exceptions_allowed === 1
        );
        // Log the filtered stores
        console.log("Stores with exceptions_allowed set to 1:", filteredStores);

        // Set the store options for the dropdown
        setStoreOptions(
          filteredStores.map((store) => ({
            id: store.store_id,
            name: `${store.store_id} - ${store.name || "Unknown"}`,
            // name:store.store_id,
            units: store.units,
          }))
        );
      } catch (err) {
        console.error("Error fetching store data:", err);
        setStoreError(err.message);
        NotificationManager.error(
          "Failed to load store options",
          "Error",
          3000
        );
      } finally {
        setIsLoadingStores(false);
      }
    };

    fetchStoreData();
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    // Ensure the value is a string and update filters
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  // Handle search action
  const handleSearch = () => {
    setSearchFilters(filters);
    console.log("filters------", filters);
    setCurrentPage(1); // Reset to first page when searching
    setRows([]);
  };
  const handleClearSearch = () => {
    const defaultFilters = {
      poNumber: "",
      dept: "",
      store: "",
      routingStatus: "",
      startDate: "",
      endDate: "",
    };

    setFilters(defaultFilters);
    setSearchFilters(defaultFilters);
    setCurrentPage(1); // Reset to first page
    setRows([]);
    AllPOServices(1, pageSize, sortBy, order, defaultFilters); // Fetch default results
  };

  // Fetch data whenever searchFilters change
  useEffect(() => {
    AllPOServices(currentPage, pageSize, sortBy, order, searchFilters);
  }, [currentPage, pageSize, sortBy, order, searchFilters]);

  // Handle table page changes
  const handlePageChange = async (page, newPageSize) => {
    const updatedPageSize = newPageSize || pageSize;
    setCurrentPage(page);
    if (newPageSize) {
      setPageSize(newPageSize);
    }
    await AllPOServices(page, updatedPageSize, sortBy, order, searchFilters);
  };

  const AllPOServices = async (
    page = currentPage,
    size = pageSize,
    sortByField = sortBy,
    sortOrder = order,
    filterValues = filters
  ) => {
    setIsLoading(true);

    try {
      const sanitizedFilters = {
        poNumber: filterValues.poNumber?.trim() || "",
        dept: filterValues.dept?.trim() || "",
        store: filterValues.store ? Number(filterValues.store) : "",
        routingStatus: filterValues.routingStatus?.trim() || "",
      };

      const response = await fetchPO(
        page,
        size,
        validSortFields.includes(sortByField) ? sortByField : "po_number",
        sortOrder,
        sanitizedFilters
      );

      const { data, totalRecords, totalPages } = response;

      if (Array.isArray(data) && data.length > 0) {
        setRows(data.map((row) => ({ ...row, id: row.po_exception_id })));
        setTotalRecords(parseInt(totalRecords));
        setTotalPages(parseInt(totalPages));
      } else {
        setTotalRecords(0);
        setTotalPages(1);
        setRows([]);
        NotificationManager.info(
          "No results found for the selected filters",
          "No Data",
          3000
        );
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.ErrorMessage || "Failed to fetch PO data.";
      console.error("Failed to fetch PO data:", errorMessage);
      setRows([]);
      // setTotalRecords(0);
      setTotalPages(1);
      setRows([]);
      NotificationManager.error(errorMessage, "Error", 5000);
    } finally {
      setIsLoading(false);
    }
  };


  const handleEdit = (rowData) => {
    setInitialData(rowData);
    setIsDialogOpen(true);
  };

  const handleDelete = (rowData) => {
    setRowToDelete(rowData);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = () => {
    setRows(rows.filter((row) => row.poNumber !== rowToDelete.poNumber));
    setIsDeleteModalOpen(false);
  };

  console.log("rowa", rows);

  return (
    
    <div className="px-5 my-1">
      <NotificationContainer />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        {/* Filter Section */}
        <Box display="flex" gap={2} width="100%">
          {/* PO Number Filter */}
          <FormControl fullWidth>
            <TextField
              label="PO Number"
              name="poNumber"
              value={filters.poNumber || ""} // Provide a default value if undefined
              onChange={handleFilterChange}
              variant="outlined"
              size="small"
            />
          </FormControl>

          {/* Department Filter */}
          <FormControl fullWidth>
            <TextField
              label="Department"
              name="dept"
              value={filters.dept || ""}
              onChange={handleFilterChange}
              variant="outlined"
              size="small"
            />
          </FormControl>

          {/* Store Dropdown Filter */}
          <FormControl fullWidth>
            <InputLabel>Store</InputLabel>
            <Select
              label="Store"
              name="store"
              value={filters.store || ""}
              onChange={(e) => {
                handleFilterChange(e); // This will update the filters store
                console.log("Selected Store:", e.target.value); // Log the selected value
              }}
              size="small"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {storeOptions.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>


          <FormControl fullWidth>
            <InputLabel>Routing Status</InputLabel>
            <Select
              label="Routing Status"
              name="routingStatus"
              value={filters.routingStatus || ""}
              onChange={handleFilterChange}
              size="small"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Approved">Approved</MenuItem>
              <MenuItem value="Declined">Declined</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Search Button */}
        <Button
          variant="contained"
          className="add-new-btn ml-1"
          onClick={handleSearch}
        >
          Search
        </Button>

        <Button
          variant="contained"
          className="add-new-btn ml-1"
          onClick={handleClearSearch}
        >
          ClearFilter
        </Button>
      </Box>
      <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
        <table style={{ tableLayout: "fixed", width: "100%" }}>
          <Table
            rows={rows}
            columns={POColumns(handleEdit, handleDelete)}
            paginationMode="server"
            currentPage={currentPage}
            pageSize={pageSize}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            onSort={(column, direction) => {
              setSortColumn(column);
              setSortOrder(direction);
            }}
            loading={isLoading}
          />
        </table>
        {isLoading && (
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            display="flex"
            justifyContent="center"
            alignItems="center"
            bgcolor="rgba(255, 255, 255, 0.8)"
            zIndex={1}
          >
            <img src={loaderGif} alt="Loading..." width={50} height={50} />
          </Box>
        )}
      </div>

      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        message="Are you sure you want to delete this PO?"
        onConfirm={handleConfirmDelete}
        onCancel={() => setIsDeleteModalOpen(false)}
      />
      <ConfirmationModal
        isOpen={isApproveModalOpen}
        message="Are you sure you want to approve this PO?"
        onConfirm={() => setIsApproveModalOpen(false)}
        onCancel={() => setIsApproveModalOpen(false)}
      />
      <ConfirmationModal
        isOpen={isDenyModalOpen}
        message="Are you sure you want to deny this PO?"
        onConfirm={() => setIsDenyModalOpen(false)}
        onCancel={() => setIsDenyModalOpen(false)}
      />
    </div>
  );
};

export default PO;
